export default "__VITE_ASSET__Ryo35Uhg__"